import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { MatTableDataSource } from "@angular/material";
import { MatTable } from "@angular/material/table";
import { Router } from "@angular/router";

@Component({
  selector: "app-editar-aspecto",
  templateUrl: "./editar-aspecto.component.html",
  styleUrls: ["./editar-aspecto.component.scss"],
})
export class EditarAspectoComponent implements OnInit {
  @ViewChild("table") table: MatTable<any>;
  tipoDocumental: any;
  isSuperUser = false;
  aspectos: Array<any>;
  aspectosInicial: Array<any>;
  edicao = false;
  noInclusesDataSource = new MatTableDataSource<any[]>([]);
  orderForm: FormGroup;
  idTipoDoc: number;

  displayedColumns = ["aspect", "name", "option"];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditarAspectoComponent>,
    public service: ConfigurarPastaServiceService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    this.tipoDocumental = data.dataDialog;
    this.isSuperUser = this.data.isSuperUser;

    if (typeof data.dataDialog.aspectos == "undefined") {
      this.aspectos = [];
    } else {
      this.aspectos = data.dataDialog.aspectos;
      this.aspectosInicial = [...this.aspectos];
    }
    this.aspectosNaoincluidos(data.dataDialog.id);
    this.idTipoDoc = data.dataDialog.id;
  }

  ngOnInit() {
    this.orderForm = this.formBuilder.group({
      nodeId: this.idTipoDoc,
      aspectos: [],
    });
  }

  aspectosNaoincluidos(id) {
    this.service.getAspectosNaoIncluido(id).subscribe((dados) => {
      this.noInclusesDataSource = new MatTableDataSource(dados);
    });
  }

  filter(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.noInclusesDataSource.filter = filter;
  }

  goToEditProperties(tipoId) {
    this.router.navigate([`/edit-properties/${this.data.clienteId ? this.data.clienteId + '/' + tipoId : tipoId}`]);
    this.dialogRef.close();
  }

  alterarEdicao() {
    if (this.edicao) {
      this.edicao = false;
    } else {
      this.edicao = true;
    }
  }

  removerItem(item) {
    let index = this.aspectos.indexOf(item);
    this.aspectos.splice(index, 1);
    this.noInclusesDataSource.data.push(item);
  }

  adicionarItem(item) {
    let index = this.noInclusesDataSource.data.indexOf(item);
    this.noInclusesDataSource.data.splice(index, 1);
    this.noInclusesDataSource.data = this.noInclusesDataSource.data;
    this.aspectos.push(item);
  }

  salvar() {
    this.orderForm.get("aspectos").setValue(this.aspectos);

    this.service.salvarAspectos(this.orderForm.value).subscribe(() => {
      this.dialogRef.close();
    });
  }

  cancel() {
    this.data.dataDialog.aspectos = this.aspectosInicial;
    this.orderForm.reset();
  }
}



// WEBPACK FOOTER //
// /app/src/app/editar-aspecto/editar-aspecto.component.ts